import axios from 'axios';
const auth = axios.create({ baseURL : 'http://csapi.compsoft.com.br:9009' });
//const auth = axios.create({ baseURL : 'http://localhost:9008'});
export default auth;